import { createApi } from '@reduxjs/toolkit/query/react';

import type { ShortcutProfile } from '@app/utils/shortcuts';

import fetchBaseQuery from '../fetchBaseQuery';

type SetShortcutProfileRequestData = {
    profileId: number;
};

type SetShortcutProfileResponseData = { success: boolean; profile: ShortcutProfile };

const userPreferencesApi = createApi({
    reducerPath: 'userPreferences',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        updateShortcutProfile: builder.mutation<SetShortcutProfileResponseData, SetShortcutProfileRequestData>({
            query: (data) => ({
                method: 'POST',
                url: '/user-preferences/shortcuts',
                body: data,
            }),
        }),
    }),
});

export default userPreferencesApi;

export const { useUpdateShortcutProfileMutation } = userPreferencesApi;
